import { PauseCircle, MessageCircle } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { waLink } from "../lib/api";

export default function Paused() {
  const { logout, config } = useAuth();
  return (
    <div className="min-h-screen grid place-items-center p-6 grain">
      <div data-testid="account-paused-screen" className="card-n p-10 max-w-md text-center space-y-5">
        <img src="/logo-mark.png" alt="NamoAI Digital" className="h-14 mx-auto" />
        <PauseCircle className="mx-auto text-orange-500" size={40} />
        <h1 className="text-3xl font-bold">Account paused</h1>
        <p className="text-slate-400">Your account is paused. Please contact support on WhatsApp to reactivate.</p>
        <a data-testid="paused-whatsapp-btn" href={waLink("Hi, my NamoAI account is paused. Please help.")} target="_blank" rel="noreferrer"
          className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white font-medium">
          <MessageCircle size={18} /> WhatsApp {config?.whatsapp}
        </a>
        <button data-testid="paused-logout-btn" onClick={logout} className="block mx-auto text-sm text-slate-500 hover:text-slate-300">Log out</button>
      </div>
    </div>
  );
}
